import { getAccessToken } from "request";
import { StatusProp } from "../interfaces/purchaseorder.types";
import { toast } from "react-toastify";
import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import { createTheme } from '@mui/material/styles';
// import axios from "axios";

export const formatCurrency = (amount: any) => {
  const formatter = new Intl.NumberFormat("en-NG", {
    // style: 'currency',
    // currency: 'NGN',
    style: "decimal",
    minimumFractionDigits: 2,
  });

  return amount ? formatter.format(amount) : "0.00";
};

export const formatWithCommas = (value: any) => {
  const formatter = new Intl.NumberFormat("en-NG", {
    style: "decimal",
  });

  return value ? formatter.format(value) : 0;
};

export const formatDateTime = (datetime: string, format?: boolean) => {
  const dateString = datetime;
  const date = new Date(dateString);
  const formattedDate = date.toLocaleString("en-GB", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
  if (datetime) return formattedDate.replace(/,/g, "");
  else return format ? "" : "N/A";
};

export const formatDateToWords = (dateText: string): string => {
  const date = new Date(dateText);
  if(dateText) {
    return date.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    })
  }
  return "";
};

export const getDateDifference = (numberOfDays: number): string => {
  // Get the current date
  const currentDate = new Date();

  // Subtract 7 days from the current date
  const pastDate = new Date(currentDate);
  pastDate.setDate(currentDate.getDate() - numberOfDays);

  // Format the date
  const formattedDate = pastDate.toLocaleDateString("en-US", {
    day: "numeric",
    month: "long",
    year: "numeric",
  });

  return formattedDate;
};

export const getDateDifferenceLeadTime = (DateTime: string) => {
  const givenDate: any = new Date(DateTime);
  const currentDate: any = new Date();

  // Calculate the difference in milliseconds
  const differenceMs = currentDate - givenDate;

  // Calculate days
  const days = Math.floor(differenceMs / (1000 * 60 * 60 * 24));

  // Calculate remaining hours, minutes, and seconds
  const hours = Math.floor(
    (differenceMs % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((differenceMs % (1000 * 60 * 60)) / (1000 * 60));
  // const seconds = Math.floor((differenceMs % (1000 * 60)) / 1000);

  return `${days} Day(s) ${hours} Hr(s) ${minutes} Min(s)`;
};

export const GUID = (length: number) => {
  // Characters to use for generating the GUID
  // const characters = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
  const characters = "0123456789";

  let guid = "";
  for (let i = 0; i < length; i++) {
    const randomIndex = Math.floor(Math.random() * characters.length);
    guid += characters.charAt(randomIndex);
  }

  return guid;
};

export var currentDatetime = new Date(
  new Date().getTime() + 1 * 60 * 60 * 1000
).toISOString();

export const POItemStatus: () => StatusProp[] = () => {
  const status: StatusProp[] = [
    { value: "", name: "All Status" },
    { value: "UNFULFILLED", name: "Unfulfilled" },
    { value: "PARTIAL", name: "Partially Fulfilled" },
    { value: "FULFILLED", name: "Fulfilled" },
  ];

  return status;
};

export const getPurchaseOrderItemStatus = (value: string) => {
  switch (value) {
    case "UNFULFILLED":
      return { value: "Unfulfilled", color: "status red" };

    case "PARTIAL":
      return { value: "Partially Fulfilled", color: "status yellow" };

    case "FULFILLED":
      return { value: "Fulfilled", color: "status green" };

    // case 4:
    //     return {value: "Completed", color: "status green"}
  }
};

export const truncateText = (text: any, maxLength: any) => {
  if (text?.length > maxLength) {
    return text.slice(0, maxLength) + "...";
  }
  return text;
};

export const customStyles = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0, 0.5)",
  },
};

export const POItemSupplyStatus: () => StatusProp[] = () => {
  const status: StatusProp[] = [
    { value: "", name: "All Status" },
    { value: "PACKAGING_IN_PROGRESS", name: "Packaging in Progress" },
    { value: "UNASSIGNED", name: "MRD Submitted" },
    { value: "READY_TO_ASSIGN", name: "Approved by C&P" },
    { value: "ASSIGNED", name: "Assigned to FF" },
    { value: "PICKED", name: "Picked Up by FF" },
    { value: "SHIPPED", name: "Shipped" },
    { value: "ARRIVED_IN_COUNTRY", name: "Arrived in Country" },
    { value: "CUSTOM_CLEARANCE", name: "Custom Clearance" },
    { value: "CLEARED_AT_CUSTOM", name: "Cleared at Custom" },
    { value: "DELIVERED_AT_BASE", name: "Delivered at Base" },
  ];

  return status;
};

export const ShipmentStatus: () => StatusProp[] = () => {
  const status: StatusProp[] = [
    { name: "New Shipment" },
    { name: "Rejected" },
    { name: "Draft Uploaded" },
    { name: "Draft Approved" },
    { name: "Final Uploaded" },
    { name: "Final Approved" },
    { name: "Shipped" },
    { name: "LCA Assigned" },
    { name: "Port Officer Desk" },
    { name: "Vessel Arrival Confirmation" },
    { name: "Custom Physical Examination Ongoing" },   
    { name: "Ready To Transfer To Total Energies Yard" },    
    { name: "Awaiting Custom Duty Payment" },
    { name: "LCA Completed Upload" },
    { name: "Shipment Delivered" }
  ];

  return status;
};

export const getShipmentStatusIndex = (value: string) => {
  switch (value) {
    case "New Shipment":
      return 1;
    case "Rejected":
      return 2;
    case "Draft Uploaded":
      return 3;
    case "Draft Approved":
      return 4;
    case "Final Uploaded":
      return 5;
    case "Final Approved":
      return 6;
    case "Shipped":
      return 7;
    case "LCA Assigned":
      return 8;
    case "Port Officer Desk":
      return 9;
    case "Vessel Arrival Confirmation":
      return 10;
    case "Custom Physical Examination Ongoing":
      return 11;
    case "Ready To Transfer To Total Energies Yard":
      return 12;
    case "Awaiting Custom Duty Payment":
      return 13;
    case "LCA Completed Upload":
      return 14;
    case "Shipment Delivered":
      return 15;
    default:
      return 1; 
  }
};

export const POItemSupplyStatusForSupplier: () => StatusProp[] = () => {
  const status: StatusProp[] = [
    { value: "", name: "All Status" },
    { value: "PACKAGING_IN_PROGRESS", name: "Packaging in Progress" },
    { value: "UNASSIGNED", name: "MRD Submitted" },
    { value: "READY_TO_ASSIGN", name: "Approved by C&P" },
    { value: "ASSIGNED", name: "Assigned to FF" },
    { value: "PICKED", name: "Picked Up by FF" },
  ];

  return status;
};

export const getPOItemSupplyStatusIndex = (value: string) => {
  switch (value) {
    case "PACKAGING_IN_PROGRESS":
      return 1;

    case "UNASSIGNED":
      return 2;

    case "READY_TO_ASSIGN":
      return 3;

    case "ASSIGNED":
      return 4;

    case "PICKED":
      return 5;

    case "SHIPPED":
      return 6;

    case "ARRIVED_IN_COUNTRY":
      return 7;

    case "CUSTOM_CLEARANCE":
      return 8;

    case "CLEARED_AT_CUSTOM":
      return 9;

    case "DELIVERED_AT_BASE":
      return 10;

    default:
      return 1;
  }
};

export const MOTChangeApprovalStatus: () => StatusProp[] = () => {
  const status: StatusProp[] = [
    { value: 1, name: "Entity Representative Raise Change Request" },
    { value: 2, name: "Shipping Officer Update Freight Costs" },
    { value: 3, name: "Entity Manager" },
    { value: 4, name: "Entity General Manager" },
    { value: 5, name: "Transit Manager" },
    { value: 6, name: "Deputy General Manager Technical Logistics" },
    { value: 7, name: "General Manager Technical Logistics" },
    { value: 8, name: "Executive Director Technical Directorate" },
  ];

  return status;
};

export const getFreightForwarderMRDStatus = (value: number) => {
  switch (value) {
    case 2:
      return { value: "Pending", color: "status red" };

    case 3:
      return { value: "Open", color: "status blue" };

    case 4:
      return { value: "Closed", color: "status green" };
  }
};

export const getCurrencySymbol = (currency: string) => {
  switch (currency) {
    case "NGN":
      return "₦";

    case "USD":
      return "$"; 

    case "EUR":
      return "€";

    case "GBP":
      return "£";

    default:
      return "";
  }
};

export const getDataInceptionYearToCurrentYear = (): number[] => {
  const currentYear = new Date().getFullYear();
  const yearsArray: number[] = [];
  const startYear = 2019

  for (let year = startYear; year <= currentYear; year++) {
    yearsArray.push(year);
  }

  return yearsArray;
};

export const getStatusAndColorForMRDUploads = (status: boolean) => {
  switch (status) {
    case null:
      return {
        color: "yellow",
        statusText: "Awaiting Approval",
        icon: "pending",
      };

    case true:
      return {
        color: "green",
        statusText: "Approved",
        icon: "check_circle",
      };

    case false:
      return {
        color: "red",
        statusText: "Rejected",
        icon: "cancel",
      };

    default:
      return {
        color: "yellow",
        statusText: "Awaiting Approval",
        icon: "pending",
      };
  }
};

/**
 * Return a string that represents the title of a chat conversation for a material
 * readiness document based on the sender of the message.
 *
 * @param {string} sender - The sender of the message. Either "TransitTeam" or "ExpeditingTeam"
 * or a user ID.
 * @param {string} companyName - The name of the company of the sender.
 * @param {string} senderRole - The role of the sender. Either "Freight Forwarder" or "Supplier"
 * or "ExpeditingTeam".
 *
 * @returns {string} A string to use as the title of the chat conversation.
 */
export const getMaterialReadinessDocumentChatTitle = (
  sender: string,
  companyName: string,
  senderRole: string
) => {
  switch (sender) {
    case "TransitTeam":
      return "Transit Team";
    case "ExpeditingTeam":
      return `Expediting Team (${senderRole})`;
    default: {
      if (senderRole.includes("FreightForwarder"))
        return `Freight Forwarder (${companyName})`;
      if (senderRole.includes("Supplier")) return `Supplier (${companyName})`;
    }
  }
};

export const totalEnergiesAddress = [
  "TotalEnergies EP Nig. Ltd, 35, Kofo Abayomi Street, Victoria Island, Eti-Osa, Lagos, Nigeria",
  "TotalEnergies EP Nigeria Ltd. Plot 25 Trans Amadi Industrial Layout, PMB 5160 and P.O. Box 695, Port-Harcourt, Rivers State, Nigeria"
] 

export const entityDepartments = [
  "Drilling",
  "Field Operations",
  "Medicals"
];

export const handleCopy = (text: string) => {
  // Implement the copy logic here
  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = text;

  // Make the textarea non-editable to avoid focus and activation
  tempTextArea.setAttribute("readonly", "");
  tempTextArea.style.position = "absolute";
  tempTextArea.style.left = "-9999px";

  document.body.appendChild(tempTextArea);
  tempTextArea.select();

  try {
      // Copy the text to the clipboard
      document.execCommand("copy");
      toast.info(`Copied! - ${text}`)
  } catch (err) {
      toast.error("Unable to copy selected item: " + err);
  } finally {
      document.body.removeChild(tempTextArea);
  }
};  

export const TRTTotalRoles = [
  "TransitOfficer",
  "EntityRepManager",
  "EntityRepGenManager",
  "TransitManager",
  "DGMTechnicalLogistics",
  "GMTechnicalLogistics",
  "EDTechnicalDirectorate",
  "PortOfficer",
  "ShippingOfficer",
  "HeadOfTransit"
];

export const TRTThirdPartyRoles = [
  "FreightForwarder",
  "LocalClearingAgent",
];

// export const TRTRoles = [
//   { role: "Supplier", color: "#FFD1DC" },
//   { role: "CAndP", color: "#D5E8D4" },
//   { role: "TransitOfficer", color: "#c6d2f7" },
//   { role: "FreightForwarder", color: "#FFECB3" },
//   { role: "EntityRepresentative", color: "#f0d5b3" },
//   { role: "EntityRepManager", color: "pink" },
//   { role: "EntityRepGenManager", color: "#c7b3d1" },
//   { role: "TransitManager", color: "#cab2b2" },
//   { role: "DGMTechnicalLogistics", color: "#95bf93" },
//   { role: "GMTechnicalLogistics", color: "#ffc4bf" },
//   { role: "EDTechnicalDirectorate", color: "#c7efff" },
//   { role: "LocalClearingAgent", color: "#EBDEF0" },
//   { role: "PortOfficer", color: "#EAEDED" },
//   { role: "ShippingOfficer", color: "#EAEDED" },
//   { role: "HeadOfTransit", color: "#EAEDED" }
// ];

export const addSpacesToPascalCase = (text: string) => {
  return text.replace(/([A-Z])/g, ' $1').trim();
};

/**
 * Safely encodes a URI component to prevent injection attacks.
 *
 * @param param - The string parameter to encode.
 * @returns The encoded URI component string.
 */
export function encodeParameter(param: string): string {
  return encodeURIComponent(param);
}

export const handleDownloadForPOItemSupplyAttachment = async (
  documentBlobStorageName: string,
  documentName: string,
  purchaseOrderItemSuppliesId: string,
) => {
  // id = purchaseOrderItemSupplyId
  try {
    const encodedDocumentName = encodeParameter(documentName);
    const encodedPurchaseOrderItemSuppliesId = encodeParameter(purchaseOrderItemSuppliesId)    
    const encodedDocumentBlobStorageName = encodeParameter(documentBlobStorageName);
    
    // Fetch the file from the API
    const baseUrl = process.env.REACT_APP_SERVER_URL;
    const requestUrl = `PurchaseOrderItem/DownloadPurchaseOrderItemSupplyAttachment/${encodedPurchaseOrderItemSuppliesId}/${encodedDocumentName}`;
    const response = await fetch(baseUrl + requestUrl, {
      method: 'GET',
      credentials: 'include',
      headers: {
          'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
      },
    });
    const blob = await response.blob();

    // Create a Blob URL
    const blobUrl = URL.createObjectURL(blob);

    // Create an anchor element
    const a = document.createElement("a");
    a.href = blobUrl;
    const currentDatetime = new Date(
      new Date().getTime() + 1 * 60 * 60 * 1000
    ).toISOString();
    const fileFormat = encodedDocumentBlobStorageName.split(".")[1];

    a.download = `${documentName}_${currentDatetime.slice(
      0,
      -5
    )}.${fileFormat}`; // Set the desired file name

    // Trigger the click event to initiate the download
    a.click();

    // Cleanup: Revoke the Blob URL
    URL.revokeObjectURL(blobUrl);
    return false
    
  } catch (error) {
    console.log("Error downloading file:", error); return false;
  }
};

export const handlePreviewForPoItemSupply = async (documentName: string, purchaseOrderItemSuppliesId: string) => {
  try {
      const encodedDocumentName = encodeParameter(documentName);
      const encodedPurchaseOrderItemSuppliesId = encodeParameter(purchaseOrderItemSuppliesId)      
      
      // Fetch the file from the API
      // const baseUrl = process.env.REACT_APP_SERVER_URL;
      // const requestUrl = new URL(`PurchaseOrderItem/PreviewPurchaseOrderItemSupplyAttachment/${encodedDocumentName}`, baseUrl);

      // // Create query parameters using URLSearchParams and Append the query string to the URL
      // requestUrl.search = new URLSearchParams({
      //   purchaseOrderItemSupplyId: encodedPurchaseOrderItemSuppliesId
      // }).toString()
      // const safeUrl = requestUrl.toString()

      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const endPoint = `PurchaseOrderItem/PreviewPurchaseOrderItemSupplyAttachment/${encodedDocumentName}`

      // Package ID and other query parameters (properly encoded)
      const params = new URLSearchParams({ purchaseOrderItemSupplyId: encodedPurchaseOrderItemSuppliesId });

      // Construct the complete URL
      const safeUrl = `${baseUrl}${endPoint}?${params.toString()}`;

      const response = await fetch(safeUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
        },
      });
      handlePreviewPDF(response)
      return false
      
  } catch (error) {
    console.log('Error downloading file:', error); return false;
  }
};

export const handleDownloadForPackageAttachment = async (
  packageId: string, 
  documentBlobStorageName: string, 
  documentName: string
) => {
  // id = purchaseOrderItemSupplyId
  try {      
      const encodedDocumentName = encodeParameter(documentName);
      const encodedPackageId = encodeParameter(packageId);
      const encodedDocumentBlobStorageName = encodeParameter(documentBlobStorageName);

      // Fetch the file from the API
      const baseUrl = process.env.REACT_APP_SERVER_URL
      const requestUrl = `Package/DownloadPackageAttachment/${encodedPackageId}/${encodedDocumentName}`
      const response = await fetch(baseUrl + requestUrl, {
          method: 'GET',
          credentials: 'include',
          headers: {
              'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
          },
      });
      const blob = await response.blob();
  
      // Create a Blob URL
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an anchor element
      const a = document.createElement('a');
      a.href = blobUrl;
      const currentDatetime = new Date(new Date().getTime() + 1 * 60 * 60 * 1000).toISOString()
      const fileFormat = encodedDocumentBlobStorageName.split(".")[1]
      
      a.download = `${documentName}_${currentDatetime.slice(0, -5)}.${fileFormat}`; // Set the desired file name
      
      // Trigger the click event to initiate the download
      a.click();
  
      // Cleanup: Revoke the Blob URL
      URL.revokeObjectURL(blobUrl);
      return false

  } catch (error) {
    console.log('Error downloading file:', error); return false;
  }
};


export const handlePreviewForPackageAttachment = async (packageId: string, documentName: string) => {
  try {
      
      const encodedDocumentName = encodeParameter(documentName);
      const encodedPackageId = encodeParameter(packageId);
      // Fetch the file from the API
      // const baseUrl = process.env.REACT_APP_SERVER_URL
      // const requestUrl = `Package/PreviewPackageAttachment/${encodedDocumentName}?packageId=${encodedPackageId}`
      // const response = await fetch(baseUrl + requestUrl, {
      //   method: 'GET',
      //   headers: {
      //       'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
      //   },
      // });
      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const endPoint = `Package/PreviewPackageAttachment/${encodedDocumentName}`

      // Package ID and other query parameters (properly encoded)
      const params = new URLSearchParams({ packageId: encodedPackageId });

      // Construct the complete URL
      const safeUrl = `${baseUrl}${endPoint}?${params.toString()}`;
      
      const response = await fetch(safeUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
        },
      });
      handlePreviewPDF(response)
      return false
  } catch (error) {
    console.log('Error downloading file:', error); return false;
  }
};

export const getDocumentBlobStorageName = (shipment: any, documentName: string) => {
  return shipment?.shippingDocumentAttachments?.reduce((prev: any, curr: any) => {
  return curr.documentName === documentName ? curr : prev;
  }, null)?.documentBlobStorageName;
};

export const handleDownloadForShippingDocuments = async (
  shipment: any, 
  documentName: string, 
  title: string) => {
  try {
      const encodedDocumentName = encodeParameter(documentName);
      const encodedShippingDocumentId = encodeParameter(shipment.id)
      

      // Fetch the file from the API
      const baseUrl = process.env.REACT_APP_SERVER_URL
      const requestUrl = `ShippingDocument/DownloadShippingDocument/${encodedShippingDocumentId}/${encodedDocumentName}`
      const response = await fetch(baseUrl + requestUrl, {
          method: 'GET',
          credentials: 'include',
          headers: {
              'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
          },
      });
      const blob = await response.blob();
  
      // Create a Blob URL
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an anchor element
      const a = document.createElement('a');
      a.href = blobUrl;
      const currentDatetime = new Date(new Date().getTime() + 1 * 60 * 60 * 1000).toISOString()            
      const fileFormat = getDocumentBlobStorageName(shipment, documentName).split(".")[1]
      
      a.download = `${title}${currentDatetime.slice(0, -5)}.${fileFormat}`; // Set the desired file name
      
      // Trigger the click event to initiate the download
      a.click();
  
      // Cleanup: Revoke the Blob URL
      URL.revokeObjectURL(blobUrl);
      return false

  } catch (error) {
    console.log('Error downloading file:', error); return false;
  }
};

export const handlePreviewForShippingDocuments = async (shipment: any, documentName: string) => {
  try {
      const encodedDocumentName = encodeParameter(documentName);
      const encodedShippingDocumentId = encodeParameter(shipment.id)      

      // Fetch the file from the API
      // const baseUrl = process.env.REACT_APP_SERVER_URL
      // const requestUrl = `ShippingDocument/PreviewShippingDocument/${encodedDocumentName}?shippingDocumentId=${encodedShippingDocumentId}`
      // const response = await fetch(baseUrl + requestUrl, {
      //   method: 'GET',
      //   headers: {
      //       'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
      //   },
      // });

      // const baseUrl = process.env.REACT_APP_SERVER_URL;
      // const requestUrl = new URL(`ShippingDocument/PreviewShippingDocument/${encodedDocumentName}`, baseUrl);

      // // Create query parameters using URLSearchParams
      // const params = new URLSearchParams({
      //   shippingDocumentId: encodedShippingDocumentId
      // });
      // requestUrl.search = params.toString(); // Append the query string to the URL

      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const endPoint = `ShippingDocument/PreviewShippingDocument/${encodedDocumentName}`

      // Package ID and other query parameters (properly encoded)
      const params = new URLSearchParams({ shippingDocumentId: encodedShippingDocumentId });

      // Construct the complete URL
      const safeUrl = `${baseUrl}${endPoint}?${params.toString()}`;
    
      const response = await fetch(safeUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
        },
      });
      handlePreviewPDF(response)
      return false
  } catch (error) {
    console.log('Error downloading file:', error); return false;
  }
};

const handlePreviewPDF = async (response: any) => {
  try {
    const base64String: any = await response.text()            
    const dataObj = JSON.parse(base64String);
    
    const base64Data = `data:application/pdf;base64, ${dataObj.data}`
    const pdfWindow = window.open("")
    if(pdfWindow) {
        pdfWindow.document.write(
            "<iframe width='100%' height='100%' src='" + base64Data + "'></iframe>"
        )
        pdfWindow.document.close(); // Needed for IE11
    }
  }catch (error) {
    console.log("Error downloading file:", error);
  }
}
export const handleDownloadForMOTChangeRequest = async (
  modeOfTransportation: any, 
  title: string) => {
  try {
      const encodedModeOfTransportationAttachmentId = encodeParameter(modeOfTransportation.id)      

      // Fetch the file from the API
      const baseUrl = process.env.REACT_APP_SERVER_URL
      const requestUrl = `ModeOfTransportation/DownloadModeOfTransportationAttachment/${encodedModeOfTransportationAttachmentId}`
      const response = await fetch(baseUrl + requestUrl, {
          method: 'GET',
          credentials: 'include',
          headers: {
              'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
          },
      });
      const blob = await response.blob();
  
      // Create a Blob URL
      const blobUrl = URL.createObjectURL(blob);
  
      // Create an anchor element
      const a = document.createElement('a');
      a.href = blobUrl;
      const currentDatetime = new Date(new Date().getTime() + 1 * 60 * 60 * 1000).toISOString()            
      const fileFormat = modeOfTransportation.documentBlobStorageName.split(".")[1]
      
      a.download = `${title}_${currentDatetime.slice(0, -5)}.${fileFormat}`; // Set the desired file name
      
      // Trigger the click event to initiate the download
      a.click();
  
      // Cleanup: Revoke the Blob URL
      URL.revokeObjectURL(blobUrl);
      return false

  } catch (error) {
    console.log('Error downloading file:', error); return false;
  }
};

export const handlePreviewForMOTChangeRequest = async (attachmentId: string) => {
  try {      
      const encodedAttachmentId = encodeParameter(attachmentId);
      const baseUrl = process.env.REACT_APP_SERVER_URL;
      const endPoint = `ModeOfTransportation/PreviewModeOfTransportationAttachment/${encodedAttachmentId}`

      // Construct the complete URL
      const safeUrl = `${baseUrl}${endPoint}`;
      
      const response = await fetch(safeUrl, {
        method: 'GET',
        credentials: 'include',
        headers: {
            'Authorization': 'Bearer ' + encodeParameter(getAccessToken())
        },
      });
      handlePreviewPDF(response)
      return false
  } catch (error) {
    console.log('Error downloading file:', error); return false;
  }
};

export const areArraysEqual = (array1: any[], array2: any[]): boolean => {
  return JSON.stringify(array1) === JSON.stringify(array2);
};

export const getDocumentNameWithoutEndingWithLCA = (documentName:string) => {
  const documentNameSplit = documentName.replaceAll("_", " ").split(" ")
  const documentNameLength = documentNameSplit.length

  return documentNameSplit.slice(0, documentNameLength-1).join(" ")
}

export const getUserManual = (role: string) => {
  switch(role) {
    case "supplier": return "Suppliers User Manual for Transit Tracker System.pdf";
    case "candp": return "C&P User Manual for Transit Tracker System.pdf";
    case "transitofficer": return "Transit Team User Manual for Transit Tracker System.pdf";
    case "freightforwarder": return "Freight Forwarder User Manual for Transit Tracker System.pdf";
    case "entityrepresentative": return "Entity Representative User Manual for Transit Tracker System.pdf";
    case "entityrepmanager": 
    case "entityrepgenmanager": 
    case "transitmanager": 
    case "dgmtechnicallogistics": 
    case "gmtechnicallogistics": 
    case "edtechnicaldirectorate": 
        return "Mode of Transportation Change Request Approvers User Manual.pdf";
    case "localclearingagent": return "Local Clearing Agent User Manual for Transit Tracker System.pdf";
    case "portofficer": return "Port Officer User Manual for Transit Tracker System.pdf";
    case "firsttimevendormanual": return "Vendor First Time Registration Manual for Transit Tracker System.pdf";
    case "vendorloginmanual": return "Vendor Login User Manual for Transit Tracker System.pdf";
    case "authenticatorappmanual": return "Vendor Register Additional Phone Numbers to Access the Transit Tracker System.pdf"
    default: return "";
  }
}

export const Months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec"
];

export const getSelectedMonthIndex = (selectedMonth: string) => {
  return String(Months.findIndex((month) => month === selectedMonth) + 1);
}

export const currencies = [
  { value: "Nigeria Naira", label: "NGN" },
  { value: "Pound Sterling", label: "GBP" },
  { value: "United States Dollar", label: "USD" },
  { value: "Euro", label: "EUR" },
]

export const handlePercentageChange = (percentageChange: number) => {
  const value = Math.abs(percentageChange);
  const hasDecimal = value % 1 !== 0;
  const formattedValue = hasDecimal ? value.toFixed(2) : value;
  if (percentageChange > 0) {
    return {
        value: `${formattedValue}%`,
        icon: "arrow_upward",
        color: "green"
    };
  } else if (percentageChange < 0) {
    return {
        value: `${formattedValue}%`,
        icon: "arrow_downward",
        color: "red"
    };
  } else {
    return {
        value: `${formattedValue}%`,
        icon: "",
        color: "grey"
    };
  }
}

export const LCADocumentsRequiredForPayment = [
    "AgentDeliveryWayBill",
    "PreReleaseGrantedByCustom",
    "ShippingAndTerminalCompanyReceipts",
    "ContainerRefundDocuments"
]

export const exportToExcel = async (data: any, fileName = `Freight_Forwarder_Report_${currentDatetime.substring(0, 10)}`) => {
  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet('Report');

  // Add headers
  worksheet.columns = [
    { header: 'MRD NUMBER', key: 'mrdNumber', },
    { header: 'PO NUMBER', key: 'purchaseOrderNumber', },
    { header: 'ITEM NUMBER', key: 'purchaseOrderItemRequestNumber', },
    { header: 'TAG', key: 'tag', },
    { header: 'QUANTITY', key: 'quantity', },
    { header: 'DESCRIPTION', key: 'description', },
    { header: 'HS CODE', key: 'hsCode', },
    { header: 'COUNTRY OF ORIGIN', key: 'countryOfOrigin', },
    { header: 'UNIT PRICE', key: 'unitPrice', },
    { header: 'CURRENCY', key: 'currency', },
    { header: 'PROJECT', key: 'project', },
    // { header: 'Name', key: 'name', width: 30 },
  ];

  // Apply bold styling to the header row
  const headerRow = worksheet.getRow(1);
  headerRow.font = { bold: true };
  
  headerRow.alignment = { vertical: 'middle', horizontal: 'left' };
  headerRow.fill = {
    type: 'pattern',
    pattern: 'solid',
    fgColor: { argb: 'FFD3D3D3' }, // Light gray background
  };
  headerRow.border = {
    top: { style: 'thin' },
    bottom: { style: 'thin' },
    left: { style: 'thin' },
    right: { style: 'thin' },
  };

  // Add data rows
  data.forEach((row: any) => {
    worksheet.addRow(row);
  });  

  // Generate buffer and save
  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  saveAs(blob, `${fileName}.xlsx`);
};

// theme css styling for the react stepper material ui component
export const theme = createTheme({
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '10px !important',
        },
      },
    },
    MuiAutocomplete: {
      styleOverrides: {
        root: {
          '.MuiOutlinedInput-root': {
            padding: '8px !important',
            borderRadius: '6px',
            '&:focus': {
              outline: 'none !important',
            },
          },
          '.MuiAutocomplete-input': {
            border: 'none !important',
            margin: '0 !important',
            fontSize: '11px !important',
          },
        },
      },
    },
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          '&.MuiSvgIcon-fontSizeMedium.MuiStepIcon-root.Mui-completed': {
            color: '#27A445 !important',
          },
          '&.MuiSvgIcon-fontSizeMedium.MuiStepIcon-root.Mui-active': {
            color: '#175FDC !important',
          },
          '&.MuiSvgIcon-fontSizeMedium.MuiStepIcon-root': {
            height: '18px !important',
          },
        },
      },
    },
    MuiStepLabel: {
      styleOverrides: {
        label: {
          '&.Mui-active': {
            fontSize: '13px !important',
          },
          '&.MuiStepLabel-alternativeLabel': {
            fontSize: '11px !important',
          },
        },
      },
    },
  },
});
